<script>
    import { TOKEN_SESSION, USER } from "../stores";
    import { createEventDispatcher } from "svelte";
    import { onMount } from "svelte";
    import GLOBAL from "../globals/GLOBALS";

    const dispatch = createEventDispatcher()
    
    export let lis_tipo = ''
    export let selected = 0
    let choosen 
    
    let JSONdata = []

    onMount(async () => {
        _GETDATA();
    });

    const _GETDATA = async () => {
        const data = { lis_tipo: lis_tipo };
        const URL = GLOBAL.URL;
        const bearer = "Bearer " + $TOKEN_SESSION;
        await fetch(`${URL}/API/listaparametros/GETDATA`, {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                Authorization: bearer,
                "Content-type": "application/json;charset=UTF-8",
            },
        })
            // Handle success
            .then((response) => response.json()) // convert to json
            .then((json) => {
                if (json.result === "success") {
                    JSONdata = json.rows;
                }
            }) //print data to console
            .catch((err) => console.log("Request Failed", err)); // Catch errors
    };

    const _onChange = () => { 
        dispatch('_onChange',{ choosen , lis_tipo })
    }

</script>

<select name="" id="" class="DropList" bind:value={choosen} on:blur={() => _onChange()} on:click={() => dispatch("click")} >
    {#each JSONdata as item}
    <option value={item} selected={item.lis_id === selected} >
        {item.lis_descripcion}
    </option>
    {:else}
    <option value="">
        <div class="spinner-border text-warning" role="status" selected=true>
            <span class="visually-hidden">Cargando...</span>
        </div>
    </option>
    {/each}
    <option value={0} selected={0 === selected} ></option>
</select>

<style>
    .DropList {
        border: none;
        width: 100%;
        padding: 5px 5px;
        border-radius: 5px;
        min-width: 10em;
    }
</style>